module.exports = __webpack_public_path__ + "static/img/about3.4307698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about3.jpg
// module id = Fe0T
// module chunks = 1